import { inject, Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { TenantComponentsRestApi } from '../../../infrastructure/api/tenant-components-rest.api';
import { TenantComponentsEntity } from '../../../domain/entities/tenant-components.entity';

export interface GetTenantComponentsResult {
  success: boolean;
  data?: TenantComponentsEntity;
  error?: string;
}

@Injectable()
export class GetTenantComponentsUseCase {
  private readonly _api = inject(TenantComponentsRestApi);

  public execute(): Observable<GetTenantComponentsResult> {
    return this._api.getComponents().pipe(
      map((data) => ({ success: true, data })),
      catchError((error: { message?: string }) => of({ success: false, error: error.message ?? 'Unknown error' })),
    );
  }
}
